// extracted by mini-css-extract-plugin
export default {"text":"CompetencyModelPage_text__0cIAL","shadow":"CompetencyModelPage_shadow__NiJvK"};